export function searchURL() {
    return `/vmpws/v2/vmp/search`;
}

export function productSearchURL(query: string) {
    return `/vmpws/v2/vmp/products/search?${query}`;
}

export function userLocationURL() {
    return `/vmpws/v2/vmp/search/userlocation`;
}

export function productGuideURL(query: URLSearchParams) {
    return `/vmpws/v2/vmp/products/productGuide?${query}`;
}

export function autocompleteURL() {
    return `/vmpws/v3/vmp/products/suggestions`;
}

export function barcodeSearchURL(barcode: string) {
    return `/vmpws/v2/vmp/products/barCodeSearch/${barcode}`;
}
